import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DataService } from '../services/data.service';
import { AuthService } from '../services/auth.service';
import { UtentiService } from '../services/utenti.service';
import { JossoService } from '../services/josso.service';

@Injectable()
export class AuthGuard implements CanActivate {
	constructor(private dataService: DataService, private authService: AuthService, private utentiService: UtentiService, private jossoService: JossoService, private router: Router) {
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot){
		console.log("GRD|AG - VORREI APRIRE LA PAGINA:", route.url[0].path, state.url);
		let userLocal = null;
		this.authService.lastVisited = state.url;
		let path: string = route.url[0].path;

		if(this.authService.aritUser){
			this.jossoService.cookieNotExpired();
			//console.log("GRD|AG - cookieNotExpired");
		}

		if(this.authService.loggedIn()){
			userLocal = this.dataService.getUtentiService().getUser();
			//console.log("GRD|AG - user", userLocal);
			if(userLocal && userLocal.id){
				if (path == 'profilo-utente' || path == 'conversazioni'){
					console.log("GRD|AG - setLastVisited", this.authService.lastVisited);
					this.setLastVisited(this.authService.lastVisited);
					return true;
				}else if(this.authService.certificated()){
					//console.log("GRD|AG - CERTIFICATO", this.dataService.getUtentiService().getPermissions(), this.dataService.getComuniService().getComuneId());
					if (this.dataService.getUtentiService().getPermissions() && this.dataService.getComuniService().getComuneId() != -1) {
						console.log("GRD|AG - PERMESSI OK", path);
						let permissions = this.dataService.getUtentiService().getPermissions();
						let pathPermesso = this.checkPermissions(path);
						if(pathPermesso){
							this.setLastVisited(this.authService.lastVisited);
						}
						return pathPermesso;
					}else if (!this.dataService.getUtentiService().getPermissions() && (path == 'dashboard' || path == 'situazione-contribuente') ) {
						console.log("GRD|AG - CITTADINO OK");
						this.setLastVisited(this.authService.lastVisited);
						return true;
					}else{
						console.log("GRD|AG - navigate check-access");
						this.router.navigate(['/check-access']);
						return false;
					}
				}else {
					console.log("GRD|AG - navigate profilo-utente");
					this.router.navigate(['/profilo-utente']);
					return false;
				}
			}else{
				console.log("GRD|AG - no user navigate check-access");
				this.router.navigate(['/check-access']);
				return false;
			}
		}else{
			//console.log("GRD|AG - no login navigate login");
			this.router.navigate(['/login']);
			this.authService.lastVisited = '/login';
			return false;
		}
	}

	checkPermissions(path, filter = "global"){
		let permissionLocal = this.dataService.getUtentiService().checkPermission(this.dataService.getComuniService().getComuneId(), path, "read", filter);
		if(path == 'profilo-utente' || path == 'dashboard'|| path == 'situazione-contribuente'|| path == 'conversazioni'){
			//console.log("checkPermission", this.dataService.getComuniService().getComuneId(), path, "read", permissionLocal);
		}
		return permissionLocal
	}

	setLastVisited(state) {
		this.dataService.setTitlePage(state);
		if (state != this.authService.lastVisited) {
			console.log("GRD|AG - SETTING LAST PAGE", state);
			localStorage.setItem('last_visited', state);
			this.authService.lastVisited = state;
		}
	}
}
